import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import account from '../../assets/images/account.svg';
import housecurrent from '../../assets/images/house-current.svg';
import creditcardicon from '../../assets/images/credit-card-icon.svg';
import mastercardicon from '../../assets/images/mastercard.svg';
import visaicon from '../../assets/images/visa.svg';
import Logo from '../../assets/images/logo.png';
import LoadingSpinner from '../common/LoadingSpinner';
import { viewForgotPassword, validateLogin, logout } from '../../actions/auth';
import { authFormUpdate, authError, loginUser, registerUser } from '../../actions/auth';
import { setAccountPanel } from '../../actions/panels';

import ProfileInformation from '../account/ProfileInformation';
import PaymentInformation from '../account/PaymentInformation';
import DeliveryAddresses from '../account/DeliveryAddresses';
import NewDeliveryAddress from '../account/NewDeliveryAddress';
import Tabs from '../common/NavigationTabs';

class AccountPage extends React.Component {

    constructor(props) {
        super(props);

        this.showSignInModal = this.showSignInModal.bind(this);
        this.showRegisterModal = this.showRegisterModal.bind(this);
        this.onLoginButtonPress = this.onLoginButtonPress.bind(this);
        this.onRegisterButtonPress = this.onRegisterButtonPress.bind(this);

        this.state = {
           signInSelected: true, 
           registerSelected: false,
           setModalVisible: false
        };
    }

    componentDidMount() {
        const token = window.localStorage.getItem('c2o.token');
        if (token) {
            this.props.dispatch(validateLogin({ token }));
        }
    }

    showSignInModal() {
        this.setState(() => ({
            signInSelected: true,
            registerSelected: false,
        }));
    }

    showRegisterModal() {
        this.setState(() => ({
            signInSelected: false,
            registerSelected: true
        }));
    }

   handleModalClose() {
        this.setState(() => ({
            setModalVisible: false
        }));
   }

   openModal() {
        this.setState(() => ({
           setModalVisible: true
        }));
   }


    onLoginButtonPress() {
        // perform basic error checking
        const { email, password, dispatch, navigation } = this.props;

        if (email === undefined || email.trim() == '') {
            dispatch(authError("E-mail cannot be blank."))
        }            
        else if (!email.match(/^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}\s*$/))
        {
            dispatch(authError("Please enter a valid e-mail address."))
        }
        else if (password === undefined || password.trim() == '') {
            dispatch(authError("Please enter a password."))
        }
        else {

            if (this.props.location && this.props.location.state && this.props.location.state.redirectTo) {
                const redirectTo = this.props.location.state.redirectTo;
                dispatch(loginUser({ email, password, history: this.props.history, redirectTo, location_id: this.props.match.params.lid, sitename: this.props.match.params.sitename }));
            }
            else {
                dispatch(loginUser({ email, password, navigation }));
            }
        }

    }

    onRegisterButtonPress() {
        // perform basic error checking
        const { acceptTerms, name, email, phone, password, password_confirm, dispatch } = this.props;
        if (name === undefined || name.trim() == '') {
            dispatch(authError("Name cannot be blank."));
        } 
        else if (email === undefined || email.trim() == '') {
            dispatch(authError("E-mail cannot be blank."));
        }            
        else if (!email.match(/^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}\s*$/))
        {
            dispatch(authError("Please enter a valid e-mail address."));
        }
        else if (password === undefined || password.trim() == '') {
            dispatch(authError("Please enter a password."));
        }
        else if (password.trim() !== password_confirm.trim()) {
            dispatch(authError("Passwords do not match."));
        }
        else if (acceptTerms === undefined || acceptTerms == false) {
            dispatch(authError("Please accept the Terms and Conditions before continuing."))
        }
        else {
            dispatch(registerUser({ name, email, phone, password, password_confirm }));
        }
    }

    renderProfileInformation() {
        return ( 
            <div>
                <div className="orders-wrapper">
                    <div className="section-header-wrapper">
                        <img src={account}  className="most-small-icons _2" />
                        <div className="medium-header">Profile Information:</div>
                    </div>
                    <div className="profile-info-wrapper">
                        <div className="information-wrapper">
                            <div className="name-title">
                                <div className="text-block-8">Name:</div>
                            </div>
                            <div className="name-info">
                                <div>{this.props.user.first_name} {this.props.user.last_name}</div>
                            </div>
                        </div>
                        <div className="information-wrapper">
                            <div className="name-title">
                                <div className="text-block-8">Phone:</div>
                            </div>
                            <div className="name-info">
                                <div>{this.props.user.phone}</div>
                            </div>
                        </div>
                        <div className="information-wrapper">
                            <div className="name-title">
                                <div className="text-block-8">Email:</div>
                            </div>
                            <div className="name-info">
                                <div>{this.props.user.email}</div>
                            </div>
                        </div>
                    </div>
                    <div className="account-button in-receipt usual-orders"
                        onClick={() => this.props.dispatch(setAccountPanel('update_profile'))}
                    >
                        <img src={account} loading="lazy" className="button-icon white" />
                        <div>Update Profile Info</div>
                    </div>
                </div>
            </div>
        );
    }

    // renderLoyaltyPoints() {
    //     return (
    //         <div>
    //             <div>
    //                 <p style={styles.titleSection}>Loyalty Points</p>
    //             </div>
    //             <div>
    //                 {/* @TODO: Add Loyalty Points after chating with Matt */}
    //             </div>
    //         </div>
    //     );
    // }

    renderDeliveryAddresses() {
        return (        
            <div className="delivery-wrapper">
                <div className="section-header-wrapper">
                    <img src={housecurrent}  className="most-small-icons _2" />
                    <div className="medium-header">Delivery Addresses:</div>
                </div>
                <div className="profile-info-wrapper">
                    <div className="information-wrapper">
                        <div className="name-title">
                            <div className="text-block-8">Default Delivery Address:</div>
                        </div>
                        <div className="name-info">
                            <div>{ (this.props.user.hasDefaultAddress) ? this.props.user.defaultAddress : "No default address set." }</div>
                        </div>
                    </div>
                    { this.props.user.defaultAddressInstructions ? (
                    <div className="information-wrapper">
                        <div className="name-title">
                            <div className="text-block-8">Special Instructions:</div>
                        </div>
                        <div className="name-info special">
                            <div>{this.props.user.defaultAddressInstructions}</div>
                        </div>
                    </div>
                        ): (
                        <div />
                    ) }
                </div>
                <div className="account-button in-receipt usual-orders"
                        onClick={() => this.props.dispatch(setAccountPanel('delivery_addresses'))}
                >
                    <img src={housecurrent} loading="lazy" className="button-icon white" />
                    <div>Update Default Address</div>
                </div>
            </div>
        );
    }

    renderPaymentInformation() {
        return (
            <div className="delivery-wrapper">
            <div className="section-header-wrapper">
                <img src={creditcardicon}  className="most-small-icons _2" />
                <div className="medium-header">Payment Information:</div>
            </div>
            <div className="profile-info-wrapper">
                <div className="information-wrapper single">
                    <div className="name-title">
                        <div className="text-block-8">Default Payment Info:</div>
                    </div>
                    <div className="credit-card-info">
                        <div className="card-card-logo-wrapper">
                            <img src={mastercardicon}  className="credit-card-logo-icon" />
                            <img src={visaicon}  className="credit-card-logo-icon" />
                        </div>
                        <div className="card-info-wrapper">
                            <div>
                            { (this.props.user.hasDefaultPayment) ?  this.props.user.defaultPayment : "No payment entered. You will have the option of saving your payment when you make your next order." }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="account-button in-receipt usual-orders"
                 onClick={() => this.props.dispatch(setAccountPanel('payment_info'))}
            >
                <img src={creditcardicon} loading="lazy" className="button-icon white" />
                <div>Update Payment Info</div>
            </div>
        </div>
        )
    }
    

    renderActivePanel() {
        switch(this.props.curPanel) {

            case 'update_profile':
                return this.renderUpdateProfile();

            case 'delivery_addresses':
                return this.renderUpdateDeliveryAddresses();

            case 'new_delivery_address':
                return this.renderNewDeliveryAddress();

            case 'payment_info':
                return this.renderUpdatePayment();
            
            default:
                return this.renderInfo();
        }
    }

    renderUpdateProfile() {
        return (
            <ProfileInformation />
        );
    }

    renderUpdateDeliveryAddresses() {
        return (
            <DeliveryAddresses />
        );
    }

    renderNewDeliveryAddress() {
        return (
            <NewDeliveryAddress />
        );
    }

    renderUpdatePayment() {
        return (
            <PaymentInformation />
        );
    }

    renderInfo() {
        return (
            <div className="section account">
                <h1 className="heading" >Your Account</h1>

                 { this.renderProfileInformation() } 

                { this.renderDeliveryAddresses() }  

                { this.renderPaymentInformation() }

                <div className="account-button in-receipt logout"
                         onClick={() => this.props.dispatch(logout())}
                    >
                        <img src={account} loading="lazy" className="button-icon white" />
                        <div>Logout</div>
                </div>
            </div>
        )
    }

    openTermsWindow() {
        window.open("https://www.click2order.ca/legal");
    }
    
    render() {

        if ( this.props.loading ) {
            return (
                <LoadingSpinner />
            )
        }

        return (    
            <div className="breakpointContainer">
                { this.props.logged_in ? this.renderActivePanel() : (
                    <div className="login-section"> 
                        <img src={Logo} className="loginlogo" />

                        <div className="auth-selection-window">                  
                            <div className="auth-button">
                                <a  
                                    className={(this.state.signInSelected == true) ? 'selected' : 'not-selected'}  
                                    onClick={() => {
                                        this.showSignInModal()
                                    }}
                                >
                                    <p className={(this.state.signInSelected == true) ? 'selected-button-text' : 'non-selected-button-text'}>Log In</p>
                                </a>
                            </div>
                            <div className="auth-button">
                                <a
                                    className={(this.state.registerSelected == true ) ? 'selected' : 'not-selected'}    
                                    onClick={() => {
                                        this.showRegisterModal()
                                    }}
                                >
                                    <p className={(this.state.registerSelected ==  true) ? 'selected-button-text' : 'non-selected-button-text'}>Sign Up</p>
                                </a>
                            </div>
                        </div>

                        {(this.state.signInSelected == true) && (
                            <div>
                                <div className="input-email-window">
                                    <input 
                                        type="text"
                                        className="text-field-input"
                                        placeholder="Email"
                                        value={this.props.email}
                                        onChange={(e) => this.props.dispatch(authFormUpdate({ prop: 'email', value: e.target.value }))}
                                    />
                                </div>
                                <div className="input-password-window">
                                    <input 
                                        type="password"
                                        className="text-field-input"
                                        placeholder="Password"
                                        value={this.props.password}
                                        onChange={(e) => this.props.dispatch(authFormUpdate({ prop: 'password', value: e.target.value }))}
                                    /> 
                                </div>

                                {this.props.error != false && (
                                    <div>
                                        <p className="error-text">{this.props.error}</p>
                                    </div>
                                )}

                                <div className="login-button">
                                    <a
                                
                                        onClick={this.onLoginButtonPress}
                                    >
                                        NEXT
                                    </a>
                                </div>
                                
                                
                                <div className="forgot-password-window">
                                    <p>
                                        <Link 
                                            to={'/'+this.props.match.params.sitename+'/'+this.props.match.params.lid+'/forgotpassword'} 
                                        >
                                            Forgot Password?
                                        </Link>  
                                    </p>
                                </div>

                                <div className="terms-conditions-link-window">
                                    <p onClick={this.openTermsWindow}>
                                            Terms and Conditions
                                    </p>
                                </div>  
                            </div>
                        )}
                        {(this.state.registerSelected == true) && (
                            <div>      
                                <div className="input-email-window"> 
                                    <input
                                        type="text" 
                                        className="text-field-input"
                                        placeholder="Name"
                                        value={this.props.name}
                                        onChange={(e) => this.props.dispatch(authFormUpdate({ prop: 'name', value: e.target.value }))}
                                    />
                                </div>
                                <div className="input-email-window">
                                    <input
                                        type="text" 
                                        className="text-field-input"
                                        placeholder="Email"
                                        value={this.props.email}
                                        onChange={(e) => this.props.dispatch(authFormUpdate({ prop: 'email', value: e.target.value }))}
                                    />
                                </div>
                                <div className="input-phone-window">
                                    <input
                                        type="text" 
                                        className="text-field-input"
                                        placeholder="(902) 555-5555"
                                        value={this.props.phone}
                                        onChange={(e) => this.props.dispatch(authFormUpdate({ prop: 'phone', value: e.target.value }))}
                                    />
                                </div>

                                <p className="login-header">Password</p>
                                
                                <div className="input-password-window">
                                    <input
                                        type="password" 
                                        className="text-field-input"
                                        placeholder="Create Password"
                                        value={this.props.password}
                                        onChange={(e) => this.props.dispatch(authFormUpdate({ prop: 'password', value: e.target.value }))}
                                    /> 
                                </div> 
                                <div className="input-password-window">
                                    <input
                                        type="password" 
                                        className="text-field-input"
                                        placeholder="Re-Enter Password"
                                        value={this.props.password_confirm}
                                        onChange={(e) => this.props.dispatch(authFormUpdate({ prop: 'password_confirm', value: e.target.value }))}
                                    /> 
                                </div>
                                {this.props.error != false && (
                                    <div>
                                        <p className="error-text">{this.props.error}</p>
                                    </div>
                                )}

                                <div className="register-button">
                                    <a
                                        onClick={this.onRegisterButtonPress}
                                    >
                                        CREATE ACCOUNT
                                    </a>
                                </div>

                                <div className="terms-conditions-link-window">
                                    <p>
                                        <Link 
                                            to={'/'+this.props.match.params.sitename+'/'+this.props.match.params.lid+'/termsconditions'} 
                                        >
                                            Terms and Conditions
                                        </Link>  
                                    </p>
                                </div>  
                            </div> 
                        )}
                    </div>
                ) }

                <Tabs 
                    lid={this.props.match.params.lid}
                    sitename={this.props.match.params.sitename}
                    section="account"
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        curPanel: state.panels.account,
        user: state.auth.user,
        logged_in: state.auth.logged_in,
        email:state.auth.email,
        name: state.auth.name,
        phone: state.auth.phone,
        password: state.auth.password,
        password_confirm: state.auth.password_confirm,
        acceptTerms: state.auth.acceptTerms,
        loading: state.auth.loading,
        error: state.auth.error 
    };
};

export default connect(mapStateToProps)(AccountPage);